import { Directive, OnChanges , ElementRef, NgZone, Output, Input, EventEmitter, NgModule } from '@angular/core';
import { CommonUtils } from '@app/common/util/common.util';
import { environment } from '@enviroments/environment';

declare var $:any;

@Directive({
  selector: '[datepicker]',
})
export class DatepickerDirective implements OnChanges  {

  @Output() dateEventEmitter = new EventEmitter();
  
  @Input() Date: Date = new Date();

  @Input() isMonthYear: boolean=false;

  constructor(
    private el:ElementRef,
    private ngZone: NgZone
  ) { }
  ngOnChanges(): void {
    let format = "yy-mm";
    let lang = CommonUtils.getLang();
    
    if(lang=='kr'){
      $.datepicker.setDefaults(
        $.datepicker.regional['kr']
      )
      format = "yy-mm";
    } 
    if(lang=='en'){
      $.datepicker.setDefaults(
        $.datepicker.regional['en']
      )
      format = "yy-mm";
    } 
    
    if(this.isMonthYear){
      $(this.el.nativeElement).datepicker( {
        dateFormat: format,
        showButtonPanel: true,
        showMonthAfterYear : true,
        
        onClose: function(dateText:any, inst:any) {
          var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
          var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
          $(this).datepicker('setDate', new Date(year, month, 1)).trigger('change');
          $('.date-picker').focusout()
        },

        beforeShow : function(input:any, inst:any) {
          inst.dpDiv.addClass('month_year_datepicker')
          setTimeout(function() {
            $(".ui-datepicker-calendar").hide();
            $(".ui-datepicker-current").hide();
          });
        },

        onChangeMonthYear: (year:any, month:any, widget:any) =>{
          setTimeout(function() {
             $('.ui-datepicker-calendar').hide();
             $(".ui-datepicker-current").hide();
          });
          const a =year+"-"+month
          this.setDate(a);
        },
      })
      $(this.el.nativeElement).datepicker("setDate", this.Date)
    }
    else{
      $(this.el.nativeElement).datepicker({
        onSelect: (date:any) =>{
          this.ngZone.run(()=>{
            this.setDate(date)
          })
        }
      })
      $(this.el.nativeElement).datepicker("setDate", this.Date)
    }
  }

  setDate(date:any){
    this.dateEventEmitter.emit(date);
  }
}
